import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsObjectService} from "../../../../../../../core/shared/service/object/mvs-object.service";
import {NsConfigCheckService} from "../../../../../service/api/ns-config-check.service";
import {NsConfigCheckResultDto} from "../../../../../model/dto/api/ns-config-check-result.dto";

@Component({
    selector: 'ns-notification-type-header',
    templateUrl: './ns-notification-type-header.component.html',
    standalone: false
})
export class NsNotificationTypeHeaderComponent implements OnInit, OnChanges, OnDestroy {

    @Input() notificationTypeId: number;

    name: string;
    groupName: string;
    configCheckResult: NsConfigCheckResultDto;
    configCheckLoading: boolean = false;
    initialized: boolean = false;

    private notificationTypeService: MvsCrudService;
    private objectSubscription: Subscription;

    constructor(
        protected coreService: MvsCoreService,
        protected objectService: MvsObjectService,
        protected configCheckService: NsConfigCheckService
    ) {
        this.notificationTypeService = this.coreService.getCrudService("ns.NsNotificationType");
    }

    ngOnInit(): void {
        this.objectSubscription = this.objectService.objectChangeEvent.subscribe(change => {
            if (change.objectType === 'ns.NsNotificationType' && change.after?.id === this.notificationTypeId) {
                this.loadNotificationType();
            }
        });

        this.initComponent();
    }

    initComponent(): void {
        this.loadNotificationType();
        this.loadConfigCheck();
    }

    loadNotificationType(): void {
        if (!this.notificationTypeId) return;

        this.notificationTypeService.get(this.notificationTypeId).subscribe(result => {
            this.name = result['name'];
            this.groupName = result['groupDtoName'];
            this.initialized = true;
        });
    }

    loadConfigCheck(): void {
        if (!this.notificationTypeId) return;

        this.configCheckLoading = true;
        this.configCheckService.checkNotificationType(this.notificationTypeId).subscribe({
            next: (result) => {
                this.configCheckResult = result;
                this.configCheckLoading = false;
            },
            error: () => {
                this.configCheckLoading = false;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) return;
        if (changes["notificationTypeId"]) {
            this.initComponent();
        }
    }

    ngOnDestroy(): void {
        if (this.objectSubscription) {
            this.objectSubscription.unsubscribe();
        }
    }
}
